export default function ImpactoEnLaExperiencia() {
  return null;
}